
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { dataSource_tonghaoV2 } from '@xt/client/dataSource/kindred-spirit'
import { Observer } from 'mobx-vue'
import MomentCard from './components/MomentCard/index.vue'
import InfiniteLoading from '@xt/www/components/infinite-loadingv2/index.vue'
import VirtualWaterfall from '@xt/www/components/virtualWaterFall/index.vue'
import { EnumTongHaoStatus } from '@xt/client/enums/kindred-spirit'
import { DairyOption, HomeworkOption } from '@xt/client/entities/course-v2/user-content'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import ConfirmModal from './components/ConfirmModal/index.vue'
import type { ConfirmModalOptions, Moment } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { Bind, Debounce } from 'lodash-decorators'
import lodash from 'lodash'

type QueryParams = {
  active: string
}

@Observer
@Component({
  components: {
    MomentCard,
    InfiniteLoading,
    UserContentPop,
    VirtualWaterfall,
    ConfirmModal
  },
  asyncData(ctx) {
    const queryParams = ctx.store.$tonghao.formatQuery(ctx.query)
    const isPrivate = false

    return {
      queryParams,
      isPrivate
    }
  }
})
export default class TonghaoPage extends Vue {
  queryParams: QueryParams

  requestTime: number = Date.now()
  needLogin: boolean = false

  @Ref()
  userContentPop: {
    showPop: (options: HomeworkOption | DairyOption) => void
    hidePop: () => void
  }

  get EnumTongHaoStatus() {
    return EnumTongHaoStatus
  }

  get bodyParams() {
    let params: string[] = []
    Object.entries(this.queryParams).forEach(([key, value]) => {
      let title: string = ''

      if (key === 'active' && value !== '') {
        title = this.tabs.filter(el => el.key === value)[0]?.title
      }

      if (title) {
        // 排除1，塞入其他选项
        // 1202 - ‘推荐’ 移除 ‘同学作品（7）’
        if (value === EnumTongHaoStatus.Discover || value === EnumTongHaoStatus.Follow) {
          params = this.tabs
            .filter(
              el =>
                !(
                  el.key === EnumTongHaoStatus.Follow ||
                  el.key === EnumTongHaoStatus.Discover ||
                  el.key === EnumTongHaoStatus.ClassmateWork
                )
            )
            .map(el => el.title)
        } else {
          params.push(title)
        }
      }
    })

    return params.join(',')
  }

  get body() {
    console.log('bodyParams', this.bodyParams)

    return {
      firstRequestTime: this.requestTime,
      topics: this.queryParams.active === EnumTongHaoStatus.Follow ? undefined : this.bodyParams, // 关注页不传topics参数
      active: this.queryParams.active
    }
  }

  get pagePagination() {
    return this.PageStore.pagePagination
  }

  get UserInfo() {
    return this.$store.$storeUser.UserInfo
  }

  get UserStore() {
    return this.$store.$storeUser
  }

  get PageStore() {
    return this.$store.$tonghao
  }

  get tabs() {
    return dataSource_tonghaoV2
  }

  // 获取动态高度
  getComptedHeightList(list) {
    return this.toJS(list).map(item => {
      let totalHeight: number = 0

      // 计算图片高度
      totalHeight +=
        Array.isArray(this.toJS(item.pictures)) && item.pictures.length > 0
          ? this.getImageHeight(item.pictures[0].originWidth, item.pictures[0].originHeight)
          : 248
      // 计算 title 间距
      totalHeight += item.sourceDescription ? 8 : 10
      // 计算 title 高度，如果超过200（一行文字宽度），则高度为36，否则为18
      totalHeight += (this.getTextWidth(item.title || item.content) ?? 0) > 200 ? 36 : 18
      // 计算 card-info 间距 + 高度 + 底部间距
      totalHeight += 12 + 28 + 12

      return {
        ...item,
        height: totalHeight
      }
    })
  }

  getTextWidth(text, font = '14px sans-serif') {
    if (!text) return null
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    if (!ctx) return null
    ctx.font = font
    return ctx.measureText(text).width
  }

  compactImageSize(originWidth: number, originHeight: number) {
    const limitWidth = 194
    const shouldHeigth = Math.floor((limitWidth * originHeight) / originWidth)

    return [limitWidth, shouldHeigth]
  }

  getImageHeight(originWidth: number, originHeight: number) {
    return Math.max(100, Math.min(248, this.compactImageSize(originWidth, originHeight)[1]))
  }

  handleClosed() {
    if (this.needLogin) {
      this.$store.$storeUser.onToggleVisible(true)
      this.needLogin = false
    }
  }

  handleOpenLogin() {
    this.needLogin = true
    this.userContentPop.hidePop()
  }

  // 弹窗内部删除事件
  handleRemoveSuccess(data: { type: 'dairy'; momentId: string }) {
    if (data.type === 'dairy' && data.momentId) {
      // 删除缓存的数据
      this.PageStore.removeItem(data.momentId)
    }
  }

  // 弹窗内部收藏事件
  handleLikeSuccess(data: { momentId: string }) {
    if (data.momentId) {
      this.PageStore.likeItem(data.momentId)
    }
  }

  // 卡片点击事件
  handleClickMoment(momentId: string) {
    if (!momentId) return

    this.userContentPop?.showPop({
      type: 'dairy',
      momentId
    })
  }

  // 卡片点赞事件
  @Debounce(350, { leading: true, trailing: false })
  @Bind()
  async handleLikeMoment(item: Moment) {
    // 未登录防御
    if (!this.UserInfo.id) {
      this.$store.$storeUser.onToggleVisible(true)
      return
    }

    try {
      await this.PageStore.onLikeMoment(item)
      this.$message.success('点赞成功')
    } catch (e) {
      if (e instanceof Error) {
        this.$message.error(e.message)
      }
    }
  }

  handleChangeTab(params: Partial<QueryParams>) {
    if (lodash.isEqual(this.queryParams, params)) return

    this.queryParams = {
      ...this.queryParams,
      ...params
    }

    this.PageStore.mapPagePagination(this.queryParams.active as EnumTongHaoStatus)

    // 切换tab数据清空 + 缓存
    this.PageStore.pagePagination.clearData(this.body)

    if (!lodash.isEqual(this.$route.query, this.PageStore.toSearchQuery(this.queryParams))) {
      this.$router.replace({ query: this.PageStore.toSearchQuery(this.queryParams) })
    }

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  // 是否加入城市
  isJoinCity: boolean = false
  isPrivate: boolean

  @Ref()
  confirmModal: {
    show: (options: ConfirmModalOptions) => void
  }

  // 判断当前是否是分桐tab
  get isShowFengTong() {
    return !!this.UserInfo.id && this.isJoinCity && this.queryParams.active === EnumTongHaoStatus.FenTong
  }

  get TabList() {
    const isLogin = !!this.UserInfo.id
    const { Follow, FenTong } = EnumTongHaoStatus

    return this.tabs.filter(item => {
      // 未登录不显示 - 关注 / 分桐
      if (!isLogin) return ![Follow, FenTong].includes(item.key as EnumTongHaoStatus)
      // 已登录，未加入城市不显示 - 分桐
      return item.key !== FenTong || this.isJoinCity
    })
  }

  changeIsPrivate() {
    this.isPrivate = !this.isPrivate
  }

  changeJoin() {
    this.isJoinCity = !this.isJoinCity
    if (this.isJoinCity === true) {
      this.handleChangeTab({ active: EnumTongHaoStatus.FenTong })
    }
  }

  openConfirmModal() {
    this.confirmModal.show({
      title: '北京分桐',
      description: '每位桐学可选择一座自己常住的城市加入，加入后可参加分桐举办的活动。',
      layoutClassName: 'confirm-modal-layout',
      confirmedHide: true,
      onOk: () => {
        this.$msg('敬请期待~')
      }
    })
  }

  async initCityList() {
    const res = await this.UserStore.initUserLocation()

    if (!res) {
      // 降级处理
      this.PageStore.Cities.getRecommendCities()
      return
    }

    this.PageStore.Cities.getLocateCities()

    console.log('created initUserLocation', this.toJS(this.UserStore.locationInfo))
  }

  created(): void {
    this.PageStore.mapPagePagination(this.queryParams.active as EnumTongHaoStatus)
    this.initCityList()
  }

  mounted() {}

  updated(): void {}

  destroyed(): void {}
}
